import reduxFetch from 'react-redux-fetch';
import apiRoutes from '../../../../app/api/routes';
import { createErrorMessage } from '../../../app/helpers/createErrorMessage';

const CreateCommunityTextService = ComposedComponent =>
  reduxFetch([
    {
      resource: 'createCommunityText',
      method: 'post',
      request: (communityTag, body, callback, t) => ({
        url: apiRoutes.communityTexts(communityTag),
        body,
        meta: {
          callback,
          toaster: {
            onErrorMessage: createErrorMessage(t, 'editCommunityTextFailed'),
            onSuccessMessage: t('editCommunityTextSuccess'),
          },
        },
      }),
    },
  ])(ComposedComponent);

export default CreateCommunityTextService;
